var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a/icon_view"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask Copy 6",
    opacity: 0.01,
    width: 16,
    height: 16,
    fill: "#ECF1F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C14.9929 8.70812 14.6514 9.37509 14.0711 9.81411L7.96 14.4957C7.22814 15.0496 6.23091 15.1563 5.38942 14.7708C4.54794 14.3853 4.00892 13.5748 4 12.6816V3.31842C4.00892 2.4252 4.54794 1.61471 5.38942 1.22921C6.23091 0.843723 7.22814 0.950443 7.96 1.50431L14.0711 6.18589C14.6514 6.62491 14.9929 7.29188 15 8Z",
    fill: "#3E4056"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_263",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 11,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C14.9929 8.70812 14.6514 9.37509 14.0711 9.81411L7.96 14.4957C7.22814 15.0496 6.23091 15.1563 5.38942 14.7708C4.54794 14.3853 4.00892 13.5748 4 12.6816V3.31842C4.00892 2.4252 4.54794 1.61471 5.38942 1.22921C6.23091 0.843723 7.22814 0.950443 7.96 1.50431L14.0711 6.18589C14.6514 6.62491 14.9929 7.29188 15 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_/color_dark_gray"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    width: 16,
    height: 16,
    fill: "#3E4056"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleIcon);
export default __webpack_public_path__ + "static/media/triangle-icon.0dbe36547218dbc2e595df4b2aaf9feb.svg";
export { ForwardRef as ReactComponent };